export default "__VITE_ASSET__Cbrj1Qw3__"